<script lang="ts" setup>
import { AppTopbar } from '~/components/layout';
</script>

<template>
  <div class="split-layout relative flex min-h-screen w-full flex-col">
    <AppTopbar mode="auth" />
    <div class="split-layout__content flex flex-1">
      <div class="split-layout__content__left hidden flex-1 md:block" />
      <div
        class="split-layout__content__right flex flex-1 items-start justify-center overflow-y-auto bg-white py-8 md:items-center md:py-0"
      >
        <div
          class="split-layout__content__border split-page-size flex flex-1 items-center justify-center px-4 sm:px-6 md:px-8 lg:px-0"
        >
          <NuxtPage :page-key="(route) => route.fullPath" class="flex-1" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.split-layout {
  &__content {
    &__left {
      position: sticky;
      top: 0;
      height: 100vh;
      background-image: url('@/assets/images/auth/background.jpg');
      background-size: cover;
      background-position: right;
      background-repeat: no-repeat;
    }
  }
}
</style>
